/**
 * The opportunity list as cards — Or's design.
 *
 * Same rules as `ListStep`: five at most, headline plus one short reason,
 * and exactly ONE action per card (§2 rules out multiple controls).
 * The "Opportunity n" eyebrow replaces the other design's rank number.
 */

import React from 'react';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { copyFor, SHARED } from '../audienceCopy';

export default function MockList({ audience, opportunities, onRequestReport, onRevise, busyStoryId, error }) {
  const copy = copyFor(audience);

  if (opportunities.length === 0) {
    return (
      <>
        <p className="mk-eyebrow">Your first list</p>
        <h1 className="mk-h1 mk-h1--sm">{copy.listTitle}</h1>
        <div className="mk-notice">{SHARED.firstListEmpty}</div>
        <div className="mk-actions">
          <button type="button" className="mk-btn mk-btn--primary" onClick={onRevise}>
            {SHARED.reviseBrief}
          </button>
        </div>
      </>
    );
  }

  return (
    <>
      <p className="mk-eyebrow">Your first list</p>
      <h1 className="mk-h1 mk-h1--sm">{copy.listTitle}</h1>
      <p className="mk-lede">{copy.listSupport}</p>

      {error && <div className="mk-notice">{error}</div>}

      <div>
        {opportunities.map((item) => (
          <article className="mk-opp" key={item.storyId}>
            <p className="mk-opp-head">Opportunity {item.position}</p>
            <h2 className="mk-opp-title">{item.headline}</h2>
            {item.reason && <p className="mk-opp-reason">{item.reason}</p>}
            {/* Kept from the other design: how much reporting sits behind
                the story. §2 bans outlets and scores; a count is neither. */}
            {item.articleCount > 0 && (
              <p className="mk-opp-meta">
                <ArticleOutlinedIcon style={{ fontSize: 15 }} aria-hidden />
                {item.articleCount === 1 ? '1 article' : `${item.articleCount} articles`}
              </p>
            )}
            {/* One report at a time, so the other cards wait — but the one
                already running must stay reachable. After a refresh it was
                the only route back to that research and it was disabled
                along with the rest, which left the visitor stranded on a
                list where nothing could be clicked. */}
            <button
              type="button"
              className={`mk-btn ${busyStoryId === item.storyId ? 'mk-btn--ghost' : 'mk-btn--primary'}`}
              onClick={() => onRequestReport(item)}
              disabled={Boolean(busyStoryId) && busyStoryId !== item.storyId}
              aria-label={busyStoryId === item.storyId
                ? `Open the research being prepared for ${item.headline}`
                : undefined}
            >
              {busyStoryId === item.storyId ? SHARED.cardPreparing : copy.cardAction}
            </button>
          </article>
        ))}
      </div>
    </>
  );
}
